import { Chip } from "@heroui/react";
import { useState, useEffect } from "react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { RenterRequisite } from "@/api/requisites/requisites.ts";

export function FinanceRenterRequisiteChip({
  renterRequisiteId,
  callback,
}: {
  renterRequisiteId: number;
  callback: (item: RenterRequisite) => void;
}) {
  const [item, setItem] = useState<RenterRequisite | null>(null);
  const items = useAppSelector((state) => state.handbooks.renterRequisites);

  useEffect(() => {
    if (renterRequisiteId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == renterRequisiteId) || null);
    }
  }, [renterRequisiteId, items]);

  return (
    <>
      {renterRequisiteId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {renterRequisiteId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={() => callback(item)}
          variant="dot"
          color="primary">
          {item?.display_name}
        </Chip>
      )}
      {renterRequisiteId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}

export function RenterRequisiteChip({
  renterRequisiteId,
}: {
  renterRequisiteId: number;
}) {
  const [item, setItem] = useState<RenterRequisite | null>(null);
  const items = useAppSelector((state) => state.handbooks.renterRequisites);

  useEffect(() => {
    if (renterRequisiteId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == renterRequisiteId) || null);
    }
  }, [renterRequisiteId, items]);

  return (
    <>
      {renterRequisiteId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {renterRequisiteId !== -1 && item !== null && (
        <Chip variant="dot" color="primary">
          {item?.display_name}
        </Chip>
      )}
      {renterRequisiteId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
